import { IComplianceSearchContextProps } from "./index";

export const tabsTablesSearchInitialState: IComplianceSearchContextProps["tabsTablesSearchState"] =
  {
    allAccountSearchTab: {
      searchAccountsByName: {
        search: {
          names: "",
        },
      },
      searchAccountsByPhone: {
        search: {
          phones: "",
        },
      },
      evaluationsRithmicAccounts: {
        search: {
          emails: "",
        },
      },
    },
    quickSearchTab: {
      subscriptionStatusTable: {
        search: {
          emails: "",
        },
      },
      allPurchasesTable: {
        search: {
          emails: "",
        },
      },
      resetsRebillsNewPurchasesTable: {
        search: {
          emails: "",
        },
      },
      searchAccountsPlansTable: {
        search: {
          emails: "",
        },
      },
      basicAccountDetailsAndSalesValue: {
        search: {
          emails: "",
        },
      },
    },
    fundedAccountQuickSearchTab: {
      heliosPassesSearchTable: {
        search: {
          names: "",
          compliance_entries_id: "",
        },
      },
      heliosWithdrawalsSearchTable: {
        search: {
          names: "",
          compliance_entries_id: "",
        },
      },
      heliosFailedSearchTable: {
        search: {
          names: "",
          compliance_entries_id: "",
        },
      },
      heliosLiveSIMTraderInformationFormSearchTable: {
        search: {
          names: "",
          email: "",
          status: "",
        },
      },
      heliosAndAppiusLiveSearchTable: {
        search: {
          names: "",
          phone: "",
          email: "",
          address: "",
        },
      },
      tcpStepsSearchTable: {
        search: {
          names: "",
          compliance_entries_id: "",
        },
      },
      gmCappersSearchTable: {
        search: {
          names: "",
          compliance_entries_id: "",
        },
      },
    },
    fundedAccountInvestigationTab: {
      fundedAccountsInvestigationSearchTable: {
        search: {
          names: "",
          email: "",
          phone: "",
          address: "",
        },
      },
    },
    watchListBanPnlTab: {
      pnLCalculatorTable: {
        search: {
          names: "",
          email: "",
        },
      },
      masterBanTable: {
        search: {
          names: "",
          email: "",
        },
      },
      heliosNotesSearchTable: {
        search: {
          names: "",
          email: "",
        },
      },
    },
  };
